import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FilterPipe } from './filter.pipe';


import { HttpClientModule } from '@angular/common/http';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/auth/token.interceptor';
import { IonicStorageModule } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NavService } from './services/nav/nav.service';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { LoginLayoutPageModule } from './layout/login-layout/login-layout.module';
import { MainLayoutPageModule } from './layout/main-layout/main-layout.module';
import { MenuPageModule } from './components/menu/menu.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { NgxSpinnerModule } from 'ngx-spinner';

import { DialogPage } from './members/dashboard/dashboard.page';

import { DialogErrorLoginPage } from './services/auth/auth.service';
import { DialogChangePasswordPage } from './members/password/password.page';
import { DialogEightPage } from './members/password/password.page';

import { DialogNullNewandVerifyPasswordPage } from './members/password/password.page';
import { DialogNullNewandVerifyPasswordCharactersLimitPage } from './members/password/password.page';

import { DialogClassificationPage } from './members/classification/classification.page';
import { DialogClassificationCategoryPage } from './members/classification-category/classification-category.page';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatCardModule,
  MatFormFieldModule,
  MatProgressSpinnerModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatRadioModule,
  MatListModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatSelectModule,
  MatTabsModule
} from '@angular/material';

import { MatMomentDateModule} from '@angular/material-moment-adapter';

library.add(fas, far, fab);

@NgModule({
  declarations: [AppComponent, DialogErrorLoginPage, DialogPage, DialogEightPage, DialogChangePasswordPage, DialogNullNewandVerifyPasswordPage, DialogNullNewandVerifyPasswordCharactersLimitPage, DialogClassificationPage,DialogClassificationCategoryPage, FilterPipe],
  entryComponents: [DialogErrorLoginPage, DialogPage, DialogEightPage, DialogChangePasswordPage, DialogNullNewandVerifyPasswordPage, DialogNullNewandVerifyPasswordCharactersLimitPage, DialogClassificationPage, DialogClassificationCategoryPage],
  imports: [
    BrowserModule,
    HttpClientModule,
    MatCardModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatListModule,
    MatDatepickerModule,
    LoginLayoutPageModule,
    MainLayoutPageModule,
    FlexLayoutModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule,
    MenuPageModule,
    NgxSpinnerModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    IonicStorageModule.forRoot()
  ],
  providers: [
    NavService,
    StatusBar,
    BarcodeScanner,
    SplashScreen,
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
